export var AuthMethod;
(function (AuthMethod) {
    AuthMethod["PASSWORD"] = "password";
    AuthMethod["SSO"] = "sso";
})(AuthMethod || (AuthMethod = {}));
